"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.remotelyModeratedCountOverviewSelector = exports.showStatisticsOverviewSelector = exports.groupedDataOverviewSelector = exports.staplesOverviewSelector = exports.aggregationIntervalOverviewSelector = exports.loadingOverviewSelector = exports.errorOverviewSelector = exports.getTotalReceivedSelector = exports.overviewReportSelector = exports.requestForReport = exports.fetchDocumentCount = exports.fetchOverviewReport = exports.setDocumentCount = exports.getOverviewFailure = exports.getOverviewReportDataSuccess = exports.setLoading = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var notifier_1 = __importDefault(require("@utils/notifier"));
var i18next_1 = __importDefault(require("i18next"));
var types_1 = require("../types");
var fillMissingStatistics_1 = require("../util/fillMissingStatistics");
var groupedDecisionData_1 = require("../util/groupedDecisionData");
var initialState = {
    overviewReportData: [],
    aggregationInterval: 'day',
    staples: types_1.STAPLES.day,
    groupedData: {},
    loading: false,
    showStatistics: false,
    remotelyModeratedCount: 0,
    error: null,
};
var overview = (0, toolkit_1.createSlice)({
    name: 'overview',
    initialState: initialState,
    reducers: {
        setLoading: function (state) {
            state.loading = true;
            state.error = null;
        },
        getOverviewReportDataSuccess: function (state, _a) {
            var payload = _a.payload;
            var overviewReportData = payload.overviewReportData, aggregationInterval = payload.aggregationInterval, staples = payload.staples, groupedData = payload.groupedData, showStatistics = payload.showStatistics;
            state.overviewReportData = overviewReportData;
            state.loading = false;
            state.error = null;
            state.aggregationInterval = aggregationInterval;
            state.staples = staples;
            state.groupedData = groupedData;
            state.showStatistics = showStatistics;
        },
        getOverviewFailure: function (state, _a) {
            var payload = _a.payload;
            state.loading = false;
            state.error = payload;
        },
        setDocumentCount: function (state, _a) {
            var payload = _a.payload;
            state.remotelyModeratedCount = payload;
        },
    },
});
exports.setLoading = (_a = overview.actions, _a.setLoading), exports.getOverviewReportDataSuccess = _a.getOverviewReportDataSuccess, exports.getOverviewFailure = _a.getOverviewFailure, exports.setDocumentCount = _a.setDocumentCount;
function fetchOverviewReport(domain, fromParam, toParam, timeZoneParam, getTotalReceived, userRoleName) {
    var _this = this;
    return (function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, report, from, to, aggregationInterval, localOverviewReport, groupedData, showStatistics, searchDocumentsData, error_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.setLoading)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, apiService_1.default.getStatsOverall({ domain: domain, from: fromParam, to: toParam, tz: timeZoneParam })];
                case 2:
                    data = (_a.sent()).data;
                    report = data.report, from = data.from, to = data.to, aggregationInterval = data.aggregationInterval;
                    localOverviewReport = (0, fillMissingStatistics_1.fillMissingStatistics)(report, from, to, aggregationInterval);
                    groupedData = (0, groupedDecisionData_1.groupedDecisionData)(localOverviewReport);
                    showStatistics = void 0;
                    if (!(getTotalReceived(localOverviewReport) > 0 || userRoleName === 'Spectator')) return [3 /*break*/, 3];
                    showStatistics = true; // if there is data in the current week, show statistics.
                    return [3 /*break*/, 6];
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, apiService_1.default.getSearchDocuments({ domain: domain })];
                case 4:
                    searchDocumentsData = (_a.sent()).data;
                    showStatistics = searchDocumentsData.total !== 0;
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    showStatistics = true;
                    return [3 /*break*/, 6];
                case 6:
                    dispatch((0, exports.getOverviewReportDataSuccess)({
                        overviewReportData: localOverviewReport,
                        aggregationInterval: aggregationInterval,
                        staples: types_1.STAPLES[aggregationInterval],
                        groupedData: groupedData,
                        showStatistics: showStatistics,
                    }));
                    return [3 /*break*/, 8];
                case 7:
                    error_2 = _a.sent();
                    dispatch((0, exports.getOverviewFailure)(error_2));
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); });
}
exports.fetchOverviewReport = fetchOverviewReport;
function fetchDocumentCount(domain, searchTimeQuery) {
    var _this = this;
    return (function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.getDocumentsCount({
                            domain: domain,
                            query: "(metadata.clientResults.result: *) AND ".concat(searchTimeQuery),
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch((0, exports.setDocumentCount)(data.count));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('error getting documents count', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.fetchDocumentCount = fetchDocumentCount;
function requestForReport(domain, formData) {
    var _this = this;
    return (function () { return __awaiter(_this, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.postReportRequest({ domain: domain }, formData)];
                case 1:
                    _a.sent();
                    notifier_1.default.success(i18next_1.default.t('statistics:REPORT_MODAL.REQUEST_REPORT_SUCCESS'));
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    console.error('error requesting for report', e_2);
                    notifier_1.default.error(i18next_1.default.t('statistics:REPORT_MODAL.REQUEST_REPORT_ERROR'));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.requestForReport = requestForReport;
exports.default = overview.reducer;
var overviewReportSelector = function (state) { return state.overview.overviewReportData; };
exports.overviewReportSelector = overviewReportSelector;
var getTotalReceivedSelector = function (state) {
    var data = (0, exports.overviewReportSelector)(state);
    return data.reduce(function (acc, item) { return acc + item.received; }, 0);
};
exports.getTotalReceivedSelector = getTotalReceivedSelector;
var errorOverviewSelector = function (state) { return state.overview.error; };
exports.errorOverviewSelector = errorOverviewSelector;
var loadingOverviewSelector = function (state) { return state.overview.loading; };
exports.loadingOverviewSelector = loadingOverviewSelector;
var aggregationIntervalOverviewSelector = function (state) { return state.overview.aggregationInterval; };
exports.aggregationIntervalOverviewSelector = aggregationIntervalOverviewSelector;
var staplesOverviewSelector = function (state) { return state.overview.staples; };
exports.staplesOverviewSelector = staplesOverviewSelector;
var groupedDataOverviewSelector = function (state) { return state.overview.groupedData; };
exports.groupedDataOverviewSelector = groupedDataOverviewSelector;
var showStatisticsOverviewSelector = function (state) { return state.overview.showStatistics; };
exports.showStatisticsOverviewSelector = showStatisticsOverviewSelector;
var remotelyModeratedCountOverviewSelector = function (state) { return state.overview.remotelyModeratedCount; };
exports.remotelyModeratedCountOverviewSelector = remotelyModeratedCountOverviewSelector;
